<div id="action-manager-container">
  <div id="action-manager-scroll">
    <app-action-queue-element [action]="action" *ngFor="let action of actionList"></app-action-queue-element>
  </div>
</div>
